import React, { FC, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useTenantCode } from 'utils/hooks/useTenantConfig';
import { StaticPermission } from 'common/auth/Authorize';
import { RateCardModel } from '@utmost.co/enterprise-models';
import { DataTableRowAction } from '@utmost.co/utmost-design-system';
import { useStaticGlobalIntl } from 'src/utils/intl/useStaticGlobalIntl';

interface Props {
  rateCard?: RateCardModel;
}

export const EditRateCardOption: FC<React.PropsWithChildren<Props>> = ({ rateCard }) => {
  const { push } = useHistory();
  const tenantCode = useTenantCode();
  const [editRateCardLabel] = useStaticGlobalIntl('settings.engagements.rateCard.edit.action');

  const onClickHandler = useCallback(() => {
    push({ pathname: `/${tenantCode}/frontdoor/add-rate-card`, state: rateCard });
  }, [rateCard, push, tenantCode]);

  return (
    <StaticPermission permissionName="RATE_CARD" permissionAction="UPDATE">
      <DataTableRowAction dataTest="edit-rate-card" onClick={onClickHandler}>
        {editRateCardLabel}
      </DataTableRowAction>
    </StaticPermission>
  );
};
